import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadRepairLogsSuccess(logs) {
  return { type: types.LOAD_REPAIR_LOGS_SUCCESS, logs };
}

export function createRepairLogSuccess(log) {
  return { type: types.CREATE_REPAIR_LOG_SUCCESS, log };
}

export function loadSiteRepairLogs(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'sites/' + parseInt(id, 10) + '/repair-logs';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadRepairLogsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function loadLatestRepairLogs(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'sites/' + parseInt(id, 10) + '/repair-logs/latest';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadRepairLogsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function createRepairLog(logDate, id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'repair-logs';
    return axios
      .post(url, {
        logDate: logDate,
        siteId: id,
      })
      .then((response) => {
        dispatch(createRepairLogSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/repairLogActions.js